// extracted by mini-css-extract-plugin
module.exports = {"base":"wideStoryCard-m__base__1UhVJ","story-data":"wideStoryCard-m__story-data__241oZ"};